import { render } from "./Complaints.vue?vue&type=template&id=78ce85b6&scoped=true"
import script from "./Complaints.vue?vue&type=script&lang=js"
export * from "./Complaints.vue?vue&type=script&lang=js"

import "./Complaints.vue?vue&type=style&index=0&id=78ce85b6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-78ce85b6"

export default script